import React, { useState, useEffect, useContext } from "react";
import { callApi, deleteAutoLogin } from "bodycodi/cmap/app/js/common";

import { DispatchContext, StateContext } from "bodycodi/cmap/app/components/common/context";
import CustomDialog from "bodycodi/cmap/app/components/common/customDialog";
import PopupHeader from "bodycodi/cmap/app/components/common/popupHeader";
import ChangeNamePop from "./changeNamePop";
import RemoveAccountPop from "./removeAccountPop";
import Img from "./img";
import background from "bodycodi/cmap/app/img/my-page-background.png";
import icon_right_gray_18 from "bodycodi/cmap/app/svg/icon_right_gray_18.svg";

type AccountMngtPopWrap = {
  updateP: Function;
};

const AccountMngtPopWrap = ({ updateP }: AccountMngtPopWrap) => {
  const { state } = useContext(StateContext);
  const { dispatch } = useContext(DispatchContext);

  const handleClose = () => {
    dispatch({ type: "POP_UP_OPEN", id: "ACCOUNT_MNGT_POP", open: { accountMngtPop: false } });
  };

  return (
    <CustomDialog open={state.accountMngtPop} onClose={handleClose}>
      <PopupHeader title="계정관리" onClickBack={handleClose} />
      {state.accountMngtPop && <AccountMngtPop updateP={updateP} />}
    </CustomDialog>
  );
};

type vo = {
  CoachVO: any;
  MobileMembersVO: any;
};

const AccountMngtPop = ({ updateP }: AccountMngtPopWrap) => {
  const { dispatch } = useContext(DispatchContext);
  const [accountData, setAccountData] = useState({
    CoachVO: {},
    MobileMembersVO: {},
  });
  const { CoachVO, MobileMembersVO }: vo = accountData;
  const [refresh, setRefresh] = useState(1);

  useEffect(() => {
    callApi("/cmap5040/viewAccountMgmt", {}, "GET").then((res) => {
      setAccountData({ ...accountData, ...res });
    });
  }, [refresh]);

  const update = () => {
    setRefresh(refresh + 1);
  };

  const clickChangePassword = () => {
    dispatch({ type: "POP_UP_OPEN", id: "CHANGE_PASSWORD_POP", open: { changePasswordPop: true } });
  };

  const clickChangeName = () => {
    dispatch({ type: "POP_UP_OPEN", id: "CHANGE_NAME_POP", open: { changeNamePop: true } });
  };

  const clickLogout = () => {
    dispatch({
      type: "ALERT_SETTING",
      data: {
        alert: true,
        cancleYn: true,
        redYn: true,
        header: "로그아웃",
        body: "로그아웃 하시겠습니까?",
        closeAlert: deleteAutoLogin,
        cancelAlert: () => ({}),
      },
    });
  };

  const clickSecession = () => {
    dispatch({ type: "POP_UP_OPEN", id: "REMOVE_ACCOUNT_POP", open: { removeAccountPop: true } });
  };

  return (
    <>
      <div className="popup-body account-mngt-pop">
        <div className="account-mngt-profile">
          <Img src={background} className="background" />
          <div className="profile-wrap">
            <Img className="profile" src={CoachVO?.coachImgUrl} />
          </div>
        </div>
        <div className="account-mngt-setting-group">
          <div className="title">계정 정보</div>
          <div className="account-mngt-setting" onClick={clickChangeName}>
            <div className="black">이름</div>
            <div className="gray">
              {MobileMembersVO.name} 강사
              <img src={icon_right_gray_18} />
            </div>
          </div>
          <div className="account-mngt-setting">
            <div className="black">이메일</div>
            <div className="gray">{MobileMembersVO.email}</div>
          </div>
          <div className="account-mngt-setting no-divider">
            <div className="black">휴대폰 번호</div>
            <div className="gray">{MobileMembersVO.mobile}</div>
          </div>
        </div>
        <div className="account-mngt-setting-group">
          <div className="title">계정 보안</div>
          <div className="account-mngt-setting" onClick={clickChangePassword}>
            <div className="black">비밀번호 변경</div>
            <div className="gray">
              <img src={icon_right_gray_18} />
            </div>
          </div>
          <div className="account-mngt-setting" onClick={clickLogout}>
            <div className="black">로그아웃</div>
            <div className="gray"></div>
          </div>
          <div className="account-mngt-setting no-divider" onClick={clickSecession}>
            <div className="black">탈퇴하기</div>
            <div className="gray"></div>
          </div>
        </div>
      </div>
      <ChangeNamePop update={update} updateP={updateP} d={MobileMembersVO} />
      <RemoveAccountPop />
    </>
  );
};

export default AccountMngtPopWrap;
